export default function VPNService() {
  const features = [
    {
      icon: 'ri-lock-line',
      title: 'Zero-Log Policy',
      description: 'We never track, record, or store your online activities. Your browsing history, connection logs, and personal data remain completely private and inaccessible to anyone, including us.'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Server Network',
      description: 'Access our worldwide network of high-performance servers strategically located across multiple continents. Enjoy unrestricted content access and optimal connection speeds wherever you are.'
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Lightning Speed',
      description: 'Experience blazing-fast connection speeds with our optimized network infrastructure. Stream, download, and browse without buffering or slowdowns, all while maintaining maximum security.'
    }
  ];

  return (
    <section id="vpn-service" className="py-32 bg-[#F8FAFB]">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="mb-20">
          <div className="text-gray-500 text-xs font-medium tracking-[3px] uppercase mb-6">
            Core Capabilities
          </div>
          <h2 className="text-[#0D1B2A] leading-[1.1]">
            <div className="text-[90px] font-extrabold tracking-tight">
              UNCOMPROMISING
            </div>
            <div className="text-[90px] font-extrabold tracking-tight">
              SECURITY FEATURES
            </div>
          </h2>
        </div>

        <div className="grid grid-cols-3 gap-10">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-[#ECEFF1] rounded-[24px] p-[60px] shadow-[0_4px_12px_rgba(0,0,0,0.06)] hover:shadow-[0_8px_24px_rgba(0,0,0,0.1)] transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center mb-8">
                <i className={`${feature.icon} text-5xl text-[#0D1B2A]`}></i>
              </div>

              <h3 className="text-[28px] font-bold text-[#0D1B2A] leading-[1.3] mb-5">
                {feature.title}
              </h3>

              <p className="text-[#5F6C7B] text-base leading-[1.7]">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
